import trackGoogleAnalytics from '../services/analytics';

export function* routerLocationChangeSaga(action) {
  yield trackGoogleAnalytics(action.payload);
}



// WEBPACK FOOTER //
// ./src/sagas/routerSagas.js